import React, { useState, useEffect } from 'react';
import Datatables from '../../DataTable/Datatables';
import { FaTrashAlt, FaEdit } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';
import { Axios } from '../../components/common/Axios';
import { notify, notifyErr } from '../../components/common/norify';
import Swal from "sweetalert2";
import TextEditor from '../../Editor/TextEditor';


const SeoPricing = () => {

    const [data, setData] = useState([]);
    const [pending, setPending] = useState(true);
    const [id, setId] = useState('');
    const [dataId, setDataId] = useState('');
    const [show, setShow] = useState(false);
    const [updatedContent, setUpdatedContent] = useState('');
    const [showUpdate, setShowUpdate] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        content: "",
        btn_text: "",
        btn_link: ""
    })
    const [priceData, setPriceData] = useState({
        title: '',
        plan: '',
        price: '',
        content: '',
    });
    const [priceDataUpdate, setPriceDataUpdate] = useState({
        title: '',
        plan: '',
        price: '',
        content: '',
    });

    const getData = async () => {
        try {
            const priceData = await Axios.get('/api/pricing');
            let [price] = priceData.data.data;
            if (price) {
                setData(price);
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    ['title']: price.title,
                    ['content']: price.content,
                    ['btn_text']: price.btn_text,
                    ['btn_link']: price.btn_link,
                }))
                setDataId(price._id);
                setUpdatedContent(price.content);
            }


        } catch (error) {
            // Handle errors
            console.error('Error:', error);
        } finally {
            setPending(false)
        }
    }

    useEffect(() => {
        getData();
    }, []);


    const handleShow = () => {
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setPriceData({
            title: '',
            plan: '',
            price: '',
            content: '',
        })
        setId('');
        reset({
            title: '',
            plan: '',
            price: '',
            content: '',
        })
    };


    const showUpdateModal = (row) => {
        setShowUpdate(true);
        getPrice(row._id);
        setId(row._id);
    };


    const handleCloseUpdate = () => {
        setShowUpdate(false);
        setPriceDataUpdate({
            title: '',
            plan: '',
            price: '',
            content: '',
        })
        reset1({
            title: '',
            plan: '',
            price: '',
            content: '',
        })
        setId('');
    };




    const getPrice = async (_id) => {
        try {
            const priceData = await Axios.get(`/api/${dataId}/9/getsubcontent/${_id}`);
            let price = priceData.data.subContent;
            if (price) {
                setPriceDataUpdate({
                    title: price.title,
                    plan: price.plan,
                    price: price.price,
                    content: price.content,
                })
                reset1({
                    title: price.title,
                    plan: price.plan,
                    price: price.price,
                    content: price.content,
                })

            }
        } catch (error) {
            // Handle errors
            console.error('Error:', error);
        }
    }


    const tableData = {
        columns: [
            {
                name: <th className='fs-6 ' >#</th>,
                cell: (row, index) => index + 1,
                width: '100px',
            },
            {
                name: <th className='fs-6 '>Title</th>,
                selector: (row) => row.title,
                width: '200px',
            },
            {
                name: <th className='fs-6 '>Plan</th>,
                selector: (row) => row.plan,
                width: '200px',
            },
            {
                name: <th className='fs-6'>Price</th>,
                selector: (row) => row.price,
                width: '220px',
            },
            {
                name: <th className='fs-6'>Content</th>,
                selector: (row) => row.content,
                width: '220px',
            },
            {
                name: <th className='fs-6'>Action</th>,
                selector: (row) => (
                    <div className='d-flex' style={{ gap: '10px' }}>
                        {/* <Link to={`/service-update/${row._id}`}> */}
                        <Button className='Add_btn_ text-white'
                            onClick={() => showUpdateModal(row)}
                            variant='contained' style={{ float: 'right', backgroundColor: '#0C0833' }}>
                            <FaEdit />
                        </Button>
                        <Button className='_delete_btn_ text-white bg-danger' variant='contained'
                            onClick={() => confirmDelete(row._id)}
                        ><FaTrashAlt /></Button>
                        {/* </Link> */}

                    </div>
                ),
                right: true,
                width: '180px',

            },
        ],
    };

    const handleInputChange2 = (fieldName, value) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: value,
        }));
    }

    const handleInputChange = (fieldName, value) => {
        setPriceData((prevPriceData) => ({
            ...prevPriceData,
            [fieldName]: value,
        }));
    };


    const handleInputChange1 = (fieldName, value) => {
        setPriceDataUpdate((prevPriceData) => ({
            ...prevPriceData,
            [fieldName]: value,
        }));
    };


    useEffect(() => {
        handleInputChange2('content', updatedContent);
    }, [updatedContent])

    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const { register: register1, handleSubmit: handleSubmit1, reset: reset1, formState: { errors: errors1 } } = useForm();

    const { register: register2, handleSubmit: handleSubmit2, reset: reset2, formState: { errors: errors2 } } = useForm();


    const onSubmit2 = async () => {
        // setPending(true);

        try {
            const response = await Axios.put(`/api/pricing/${dataId}`, formData);
            if (response.status === 200 || 201) {
                notify('Update Successfully');
                setTimeout(() => {
                    getData();
                }, 1500);
                reset2({
                    title: "",
                    content: "",
                    btn_text: "",
                    btn_link: ""
                })
            }
        } catch (error) {
            notifyErr('Something went wrong')
            console.error(error);
        }

    };


    const onSubmit = async () => {
        // setPending(true);

        try {
            const response = await Axios.post(`/api/${dataId}/9/sub-content`, priceData);
            if (response.status === 200 || 201) {
                notify('Plan Added Successfully');
                setTimeout(() => {
                    getData();
                }, 1500);
            }
        } catch (error) {
            notifyErr('Something went wrong')
            console.error(error);
        }

    };


    const onUpdate = async () => {
        // setPending(true);

        try {
            const response = await Axios.put(`/api/${dataId}/9/sub-content/${id}`, priceDataUpdate);
            if (response.status === 200 || 201) {
                notify('Update Successfully');
                setTimeout(() => {
                    getData();
                }, 1500);
            }
        } catch (error) {
            notifyErr('Something went wrong')
            console.error(error);
        }

    };


    const handleDelete = async (id) => {
        try {
            const response = await Axios.delete(`/api/${dataId}/9/deletesubcontent/${id}`);
            if (response.status === 200) {
                setTimeout(() => {
                    getData();
                }, 2000);
            }
            Swal.fire({
                title: 'Deleted!',
                text: 'Your data has been deleted.',
                icon: 'success',
                confirmButtonColor: '#0C0833',
            });
        } catch (error) {
            console.error(error);

            Swal.fire({
                title: 'Error',
                text: 'An error occurred while deleting the data.',
                icon: 'error',
            });
        }
    };

    const confirmDelete = (id) => {
        Swal.fire({
            title: 'Are you sure to Delete?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0C0833',
            cancelButtonColor: 'grey',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {

            if (result.value) {
                console.log(result)
                handleDelete(id);
            }
        });
    };


    return (
        <>
            <div className='service-page'>
                <Helmet>
                    <title>SEO Pricing</title>
                </Helmet>

                <section id="main-content" style={pending ? { opacity: '0.5' } : { opacity: '1' }}>
                    <ToastContainer />

                    <div className="row">
                        <div className="col-lg-12">
                            <span className='p-3 fw-bold'>Expertise</span>
                        </div>
                    </div>

                    <section classNAme="card  cardSectionBorder my-3">
                        <div className='m-2'>
                            <Form className='row m-0' onSubmit={handleSubmit2(onSubmit2)}>
                                <Form.Group className="mb-3 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control type="text" placeholder="Heading" id="heading" value={formData.title}
                                        {...register2("title", {
                                            required: false,
                                            onChange: (e) => handleInputChange2('title', e.target.value)
                                        })}
                                    />

                                    {errors2.title && (
                                        <div className='errMsg text-danger'>Title is required</div>
                                    )}

                                </Form.Group>

                                <Form.Group className="mb-3 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <Form.Label>Content</Form.Label>
                                    <TextEditor data={updatedContent} setUpdatedContent={setUpdatedContent} />
                                  

                                </Form.Group>

                                <Form.Group className="mb-3 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <Form.Label>Btn_text</Form.Label>
                                    <Form.Control type="text" placeholder="btn_text" id="btn_text" value={formData.btn_text}
                                        {...register2("btn_text", {
                                            required: false,
                                            onChange: (e) => handleInputChange2("btn_text", e.target.value)
                                        })}
                                    />

                                    {errors2.btn_text && (
                                        <div className='errMsg text-danger'>Btn text is required</div>
                                    )}

                                </Form.Group>


                                <Form.Group className="mb-3 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <Form.Label>Btn_url</Form.Label>
                                    <Form.Control type="text" placeholder="btn link" id="btn_link" value={formData.btn_link}
                                        {...register2("btn_link", {
                                            required: false,
                                            onChange: (e) => handleInputChange2("btn_link", e.target.value)
                                        })}
                                    />

                                    {errors2.btn_link && (
                                        <div className='errMsg text-danger'>Btn <i class="fa fa-link" aria-hidden="true"></i> is required</div>
                                    )}

                                </Form.Group>

                                <hr></hr>
                                <div className='btn-d d-flex justify-content-center'>
                                    <Button type='submit' className=' Add_btn_ text-white' variant='contained'>
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </section>

                    <section className='mt-5 mx-3'>
                        <section className="wrapper _blogs">
                            <div className="row">
                                <div className="col-lg-6">
                                    <span className='p-3 fw-bold'>SEO Pricing</span>
                                </div>

                                <div className='col-lg-6 pb-2 btn-d d-flex justify-content-end'>
                                    <Button className='Add_btn_ text-white' variant='contained' style={{ float: 'right' }}
                                        onClick={handleShow}
                                    >
                                        Add Plan
                                    </Button>
                                </div>
                            </div>
                        </section>
                        <Card className="mt-3">
                            <div className="main " >
                                <Datatables data={data?.subContent} columns={tableData.columns} />
                            </div>
                        </Card>

                    </section>

                </section>
            </div>


            {/*Add Modal */}
            <Modal show={show} onHide={handleClose} className='' style={{ zIndex: '99999' }}>
                <ToastContainer />
                <Modal.Header closeButton>

                    <Modal.Title>Add Plan</Modal.Title>
                </Modal.Header>
                <Form className='row m-2' onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <Modal.Body>

                        <Form.Group className="mb-3" >
                            <Form.Label>Title</Form.Label>
                            <Form.Control type="text" placeholder="Title" value={priceData.title}
                                {...register("title", {
                                    required: true,
                                    onChange: (e) => handleInputChange('title', e.target.value)
                                })}
                            />

                            {errors.title && (
                                <div className='errMsg text-danger'>title is required</div>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Plan</Form.Label>
                            <Form.Control type="text" placeholder="Plan" value={priceData.plan}
                                {...register("plan", {
                                    required: true,
                                    onChange: (e) => handleInputChange('plan', e.target.value)
                                })}
                            />

                            {errors.plan && (
                                <div className='errMsg text-danger'>plan is required</div>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Price</Form.Label>
                            <Form.Control type="text" placeholder="Price" value={priceData.price}
                                {...register("price", {
                                    required: true,
                                    onChange: (e) => handleInputChange('price', e.target.value)
                                })}
                            />

                            {errors.price && (
                                <div className='errMsg text-danger'>Price is required</div>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>content</Form.Label>
                            <Form.Control type="text" placeholder="Content" id="content" value={priceData.content}
                                {...register("content", {
                                    required: true,
                                    onChange: (e) => handleInputChange('content', e.target.value)
                                })}
                            />

                            {errors.content && (
                                <div className='errMsg text-danger'>content is required</div>
                            )}
                        </Form.Group>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button type='submit' className='text-white' variant='contained' style={{ backgroundColor: '#0C0833' }} >
                            Add
                        </Button>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>

                    </Modal.Footer>
                </Form>
            </Modal>


            {/* update */}
            <Modal show={showUpdate} onHide={handleCloseUpdate} style={{ zIndex: '99999' }}>
                <ToastContainer />
                <Modal.Header closeButton>
                    <Modal.Title>Update Plan</Modal.Title>
                </Modal.Header>
                <Form className='row m-2' onSubmit={handleSubmit1(onUpdate)} autoComplete="off">
                    <Modal.Body>
                        <Form.Group className="mb-3" >
                            <Form.Label>Title</Form.Label>
                            <Form.Control type="text" placeholder="Title" value={priceDataUpdate.title}
                                {...register1("title", {
                                    required: true,
                                    onChange: (e) => handleInputChange1('title', e.target.value)
                                })}
                            />

                            {errors1.title && (
                                <div className='errMsg text-danger'>title is required</div>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Plan</Form.Label>
                            <Form.Control type="text" placeholder="Plan" value={priceDataUpdate.plan}
                                {...register1("plan", {
                                    required: true,
                                    onChange: (e) => handleInputChange1('plan', e.target.value)
                                })}
                            />

                            {errors1.plan && (
                                <div className='errMsg text-danger'>plan is required</div>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Price</Form.Label>
                            <Form.Control type="text" placeholder="Price" value={priceDataUpdate.price}
                                {...register1("price", {
                                    required: true,
                                    onChange: (e) => handleInputChange1('price', e.target.value)
                                })}
                            />

                            {errors1.price && (
                                <div className='errMsg text-danger'>Price is required</div>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>content</Form.Label>
                            <Form.Control type="text" placeholder="Content" id="content" value={priceDataUpdate.content}
                                {...register1("content", {
                                    required: true,
                                    onChange: (e) => handleInputChange1('content', e.target.value)
                                })}
                            />

                            {errors1.content && (
                                <div className='errMsg text-danger'>content is required</div>
                            )}
                        </Form.Group>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit" variant="contained" className='text-white' style={{ backgroundColor: '#0C0833' }}  >
                            Update
                        </Button>
                        <Button variant="secondary" onClick={handleCloseUpdate}>
                            Close
                        </Button>

                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

export default SeoPricing